import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import ScrollToTop from 'components/consumer/blog/components/ScrollToTop/ScrollToTop';
import CustomerDashboardPageTemplate from 'components/consumer/CustomerDashboardPageTemplate';
const UpChargeSuccess = t0 => {
  const $ = _c(16);
  const {
    planName,
    upholsteryName,
    productName
  } = t0;
  const t1 = planName ? "protection-plans-page" : "orders-page";
  const t2 = planName ? "Protection Plans" : "Orders";
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ScrollToTop delay={500} />;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  const t4 = planName ? "Your Protection plan has been confirmed." : "Your order has been confirmed.";
  let t5;
  if ($[1] !== t4) {
    t5 = <div className="text-xl font-bold mb-[.325rem] text-brand-dark">Congrats!{" "}{t4}</div>;
    $[1] = t4;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] !== planName || $[4] !== productName || $[5] !== upholsteryName) {
    t6 = <div className="text-base">{planName ? <>{planName} has been applied to your {productName}</> : upholsteryName && productName ? <>{upholsteryName} has been applied to your {productName}. Our team can start the process of building your furniture. We'll provide you with live build updates as we move through the production process so you're in the know every step of the way.</> : <>Upholstery has been successfully applied. We'll start the process of building your furniture, and we'll provide you with live build updates as we move through the production process.</>}</div>;
    $[3] = planName;
    $[4] = productName;
    $[5] = upholsteryName;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t5 || $[8] !== t6) {
    t7 = <div className="p-8 text-brand bg-brand-lighter">{t5}{t6}</div>;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t2 || $[11] !== t7) {
    t8 = <CustomerDashboardPageTemplate title={t2}>{t3}{t7}</CustomerDashboardPageTemplate>;
    $[10] = t2;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t1 || $[14] !== t8) {
    t9 = <div data-xc={t1}>{t8}</div>;
    $[13] = t1;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  return t9;
};
UpChargeSuccess.propTypes = {
  planName: PropTypes.string,
  productName: PropTypes.string,
  upholsteryName: PropTypes.string
};
export default UpChargeSuccess;